<app-menu></app-menu>
<div class="background-img"></div>
<app-about id="about"></app-about>
<app-associations></app-associations>
<app-list-editions></app-list-editions>
<app-contact id="contact"></app-contact>
<app-footer></app-footer>
<app-scroll-to-top></app-scroll-to-top>
